import { httpClient } from "../../../utils/HttpClient";
import { ApiEndpoint } from "../../../utils/ApiEndpoint";

export const getShortLinksReport = async ({ token, uid_partner }) => {
  const response = await httpClient(
    "GET",
    `${ApiEndpoint}campaigns/shortLinks/${uid_partner}`,
    {},
    token,
  );

  return await response.data;
};

export const getHostLinksReport = async ({ token, uid_partner }) => {
  const response = await httpClient(
    "GET",
    `${ApiEndpoint}administration/hostspartner/${uid_partner}`,
    {},
    token,
  );

  return await response.data;
};

export const changeStatusShortLink = async ({
  token,
  uid_partner,
  idRecordToInactivate,
}) => {
  const response = await httpClient(
    "POST",
    `${ApiEndpoint}campaigns/changeShortLink`,
    {
      idpartner: uid_partner,
      idshortlink: idRecordToInactivate,
    },
    token,
  );

  return await response.data;
};
